import useCurrency from '@/app/hooks/useCurrency';
import { useProductsData } from '@/queries/Products';
import type { ListProduct } from '@/queries/utils/mapProductFragmentToListProduct';
import getProductListPriceRange from '@/utils/getProductListPriceRange';

import type { BaseStoreRingData } from '../_types/types';

const useRingCarouselData = ({
  baseData,
}: {
  baseData: BaseStoreRingData[];
}) => {
  const { currencyCode } = useCurrency();
  const { data: productsQueryData } = useProductsData({
    includeInventory: false,
    productKeys: baseData.map((ringData) => ringData.productKey),
  });

  const productsQueryDataByKey = productsQueryData?.reduce(
    (acc, cur) => ({
      ...acc,
      [cur.productKey]: cur,
    }),
    {} as Record<string, ListProduct>,
  );

  const products = baseData.map((baseProduct) => {
    const productDataFromQuery =
      productsQueryDataByKey?.[baseProduct.productKey];

    return {
      ...baseProduct,
      priceInfo: {
        discountedPrice:
          productDataFromQuery?.discountedPrice.discountedPrice?.amount,
        basePrice: productDataFromQuery?.price?.amount,
        currencyCode,
      },
    };
  });

  const prices = products.map(
    ({ priceInfo: { discountedPrice, basePrice } }) => ({
      discountedPrice,
      basePrice,
    }),
  );
  const priceRange = getProductListPriceRange(prices);

  return {
    products,
    priceRange,
  };
};

export default useRingCarouselData;
